import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const money = (amount, currency = "CAD") =>
  new Intl.NumberFormat("en-CA", { style: "currency", currency }).format(amount);

export const api = axios.create({ baseURL: API });


export const HARNESS_SET = {
  "Blend Orange": "https://cdn.shopify.com/s/files/1/0728/3513/7645/files/harness-set-blend-orange__9497b144177a.jpg?v=1788444576",
  Orange: "https://cdn.shopify.com/s/files/1/0728/3513/7645/files/harness-set-orange__5ae81b77380c.jpg?v=1788444576",
  Pink: "https://cdn.shopify.com/s/files/1/0728/3513/7645/files/harness-set-pink__1d3ebfca2a44.jpg?v=1788444576",
  Blue: "https://cdn.shopify.com/s/files/1/0728/3513/7645/files/harness-set-blue__c56bba99aaca.jpg?v=1788444576",
  Red: "https://cdn.shopify.com/s/files/1/0728/3513/7645/files/harness-set-red__f270c01a415b.jpg?v=1788444576",
  Black: "https://cdn.shopify.com/s/files/1/0728/3513/7645/files/harness-set-black__3165af5d1a80.jpg?v=1788444576",
  Emerald: "https://cdn.shopify.com/s/files/1/0728/3513/7645/files/harness-set-emerald__e179156b10e3.jpg?v=1788444576",
};
export const HARNESS_ONLY = {
  "Blend Orange": "https://cdn.shopify.com/s/files/1/0728/3513/7645/files/harness-only-blend-orange__d94851d7365e.jpg?v=1788444576",
  Orange: "https://cdn.shopify.com/s/files/1/0728/3513/7645/files/harness-only-orange__7c56d80bf6af.jpg?v=1788444576",
  Blue: "https://cdn.shopify.com/s/files/1/0728/3513/7645/files/harness-only-blue__36cc139892be.jpg?v=1788444576",
  Pink: "https://cdn.shopify.com/s/files/1/0728/3513/7645/files/harness-only-pink__a00cd4d22a11.jpg?v=1788444576",
  Black: "https://cdn.shopify.com/s/files/1/0728/3513/7645/files/harness-only-black__d878c0ff65df.jpg?v=1788444576",
  Red: "https://cdn.shopify.com/s/files/1/0728/3513/7645/files/harness-only-red__3c714394ebb0.jpg?v=1788444576",
  Emerald: "https://cdn.shopify.com/s/files/1/0728/3513/7645/files/harness-only-emerald__0c768961a1ab.jpg?v=1788444576",
};
const HARNESS_VARIANTS = { "Harness + Leash Set": HARNESS_SET, "Harness Only": HARNESS_ONLY };
const HARNESS_SHOWCASE = "https://cdn.shopify.com/s/files/1/0728/3513/7645/files/harness-showcase__2b4c18e1f864.jpg?v=1788444576";

// Real customer dog photos — shown only in the lifestyle band under each product.
const WORN = {
  harness: "https://cdn.shopify.com/s/files/1/0728/3513/7645/files/lifestyle-harness-worn__zofe419h_pexels-paulvanyork-26824543.webp?v=1788444576",
  leash: "https://cdn.shopify.com/s/files/1/0728/3513/7645/files/lifestyle-leash-worn__8e97ed5722f8.jpg?v=1788444576",
  collar: "https://images.unsplash.com/photo-1656167038824-ff05f44f775a?crop=entropy&cs=srgb&fm=jpg&q=90&w=2000",
};

export const COLLAR_COLOURS = {
  Brown: "https://cdn.shopify.com/s/files/1/0728/3513/7645/files/collar-brown__0e4dc373864d.jpg?v=1788444576",
  Black: "https://cdn.shopify.com/s/files/1/0728/3513/7645/files/collar-black__c7eefa42cc6e.jpg?v=1788444576",
  Blue: "https://cdn.shopify.com/s/files/1/0728/3513/7645/files/collar-blue__9e90c8105e3a.jpg?v=1788444576",
  Teal: "https://cdn.shopify.com/s/files/1/0728/3513/7645/files/collar-teal__45e00408cb37.jpg?v=1788444576",
  Green: "https://cdn.shopify.com/s/files/1/0728/3513/7645/files/collar-green__c39095456491.jpg?v=1788444576",
  Yellow: "https://cdn.shopify.com/s/files/1/0728/3513/7645/files/collar-yellow__b741abfec852.jpg?v=1788444576",
  Orange: "https://cdn.shopify.com/s/files/1/0728/3513/7645/files/collar-orange__ba5c946a86e2.jpg?v=1788444576",
  Red: "https://cdn.shopify.com/s/files/1/0728/3513/7645/files/collar-red__de11c6da8c8c.jpg?v=1788444576",
  Purple: "https://cdn.shopify.com/s/files/1/0728/3513/7645/files/collar-purple__ce65e8bdf0b0.jpg?v=1788444576",
  Tan: "https://cdn.shopify.com/s/files/1/0728/3513/7645/files/collar-tan__c79db9610e41.jpg?v=1788444576",
  White: "https://cdn.shopify.com/s/files/1/0728/3513/7645/files/collar-white__04ba61442f63.jpg?v=1788444576",
  Pink: "https://cdn.shopify.com/s/files/1/0728/3513/7645/files/collar-pink__cc6112b7f83c.jpg?v=1788444576",
  "Light Blue": "https://cdn.shopify.com/s/files/1/0728/3513/7645/files/collar-light-blue__43af4a5777e9.jpg?v=1788444576",
};
const COLLAR_DETAIL = "https://cdn.shopify.com/s/files/1/0728/3513/7645/files/collar-detail__0adcc3d7d196.jpg?v=1788444576";

export const LEASH_COLOURS = {
  Grey: "https://cdn.shopify.com/s/files/1/0728/3513/7645/files/leash-grey__8e0c047f2dfb.jpg?v=1788444576",
  Black: "https://cdn.shopify.com/s/files/1/0728/3513/7645/files/leash-black__c61ae6ef536c.jpg?v=1788444576",
  Blue: "https://cdn.shopify.com/s/files/1/0728/3513/7645/files/leash-blue__1158be4b587c.jpg?v=1788444576",
  Pink: "https://cdn.shopify.com/s/files/1/0728/3513/7645/files/leash-pink__5a6c501e26dc.jpg?v=1788444576",
};
const LEASH_DETAIL = "https://cdn.shopify.com/s/files/1/0728/3513/7645/files/leash-detail__51b0466bd521.jpg?v=1788444576";
const HARNESS_DETAIL = "https://cdn.shopify.com/s/files/1/0728/3513/7645/files/harness-detail__833d7311e377.jpg?v=1788444576";

// Static fallback so the storefront renders instantly even before the API resolves.
export const PRODUCTS = [
  {
    slug: "no-pull-dog-harness",
    name: "No-Pull Dog Harness + Matching Leash",
    tagline: "Move Together",
    price: 39.99,
    stylePrices: { "Harness + Leash Set": 39.99, "Harness Only": 34.99 },
    currency: "CAD",
    short:
      "A breathable step-in mesh harness with reflective strips and an adjustable fit — available with a matching leash or on its own.",
    gallery: [
      HARNESS_SET["Blend Orange"],
      HARNESS_SET.Orange,
      HARNESS_SET.Black,
      HARNESS_SET.Blue,
      HARNESS_SET.Pink,
      HARNESS_SET.Red,
      HARNESS_SET.Emerald,
    ],
    colorImages: HARNESS_SET,
    variantImages: HARNESS_VARIANTS,
    extraImages: [HARNESS_DETAIL],
    showcaseImage: HARNESS_SHOWCASE,
    lifestyleImage: WORN.harness,
  },
  {
    slug: "retractable-dog-leash",
    name: "Retractable Dog Leash",
    tagline: "Roam Further",
    price: 37.99,
    currency: "CAD",
    short:
      "A retractable leash with a one-touch brake and an ergonomic grip — room to explore while you stay in control.",
    gallery: [LEASH_COLOURS.Grey, LEASH_COLOURS.Black, LEASH_COLOURS.Blue, LEASH_COLOURS.Pink],
    colorImages: LEASH_COLOURS,
    extraImages: [LEASH_DETAIL],
    showcaseImage: LEASH_COLOURS.Grey,
    lifestyleImage: WORN.leash,
  },
  {
    slug: "personalized-dog-collar",
    name: "Personalized Dog Collar",
    tagline: "Always Find Home",
    price: 34.99,
    currency: "CAD",
    short:
      "A padded faux-leather collar with an engraved nameplate for your dog's name and your phone number — so they always find the way home.",
    gallery: [COLLAR_COLOURS.Brown, COLLAR_DETAIL],
    colorImages: COLLAR_COLOURS,
    extraImages: [COLLAR_DETAIL],
    showcaseImage: COLLAR_COLOURS.Brown,
    lifestyleImage: WORN.collar,
    lifestyleFocus: "center 82%",
  },
];

export const BUNDLE = {
  slug: "walk-kit",
  name: "The Walk Kit",
  tagline: "The full set",
  price: 89.99,
  // Derived from the three component prices so savings update automatically if prices change.
  compareAt: Number((39.99 + 37.99 + 34.99).toFixed(2)),
  currency: "CAD",
  short:
    "Harness + matching leash and a personalized collar — everything for the walk, for less than buying them apart.",
  hero: "/images/walk-kit.jpg",
  includes: ["No-Pull Harness + Leash", "Retractable Leash", "Personalized Collar"],
  images: [HARNESS_SET["Blend Orange"], LEASH_COLOURS.Grey, COLLAR_COLOURS.Brown],
};

export const LIFESTYLE = {
  collarWorn: "https://cdn.shopify.com/s/files/1/0728/3513/7645/files/lifestyle-collar-worn-alt__665585794a62.jpg?v=1788444576",
  hero: "https://images.unsplash.com/photo-1771598480165-f7a557822168?crop=entropy&cs=srgb&fm=jpg&q=85&w=2000",
  forestPath:
    "https://images.unsplash.com/photo-1764845700565-5eb3a086428d?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  woods:
    "https://images.unsplash.com/photo-1548363793-9b39b30696de?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  running:
    "https://images.unsplash.com/photo-1737048550393-a8ef08416ad1?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  roadTrip:
    "https://images.unsplash.com/photo-1703595860766-1fa1e284549a?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  cityWalk:
    "https://images.unsplash.com/photo-1652710350281-bfe789af81e1?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
};
